import RModal from '../../../../components/Rsuite/Modal';
import { CustomButton } from '../../../../components/CustomButton';
import { useCustomTheme } from '../../../../hooks/useCustomTheme';

export function DeleteModal({ program, onClose, onConfirm }) {
  return (
    <RModal
      open={Boolean(program)}
      onClose={onClose}
      title={`Excluir Fidelidade > ${program.Nome}`}
      footer={
        <>
          <CustomButton onClick={onConfirm} appearance="primary">
            Excluir
          </CustomButton>
          <CustomButton onClick={onClose} appearance="ghost">
            Fechar
          </CustomButton>
        </>
      }
    >
      <DeleteModalMessage />
    </RModal>
  );
}

function DeleteModalMessage() {
  const { theme } = useCustomTheme();

  return (
    <span style={{ color: theme.colors.textSecondary }}>
      Tem certeza que deseja excluir este programa de fidelidade? Os benefícios já concedidos aos
      clientes deixam de poder ser usados assim que este programa é excluído ou desativado.
    </span>
  );
}
